import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import Image from 'components/Image';

export const CardImage = styled(Image)`
  width: 100%;
  height: 284px;
  transition: opacity 100ms ease-in-out;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  object-fit: cover;
  &:hover {
    cursor: pointer;
  }
  ${media.l` height: 230px; `};
  ${media.m` height: 250px; `};
  ${media.s` height: 200px; `};
  ${media.xs` height: auto; `};
`;
